var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C13.852 0 14.297 0.986 13.783 1.623L13.707 1.707L7.707 7.707C7.53481 7.87918 7.30571 7.98261 7.06268 7.99789C6.81965 8.01317 6.5794 7.93925 6.387 7.79L6.293 7.707L0.292999 1.707L0.209999 1.613L0.155999 1.536L0.101999 1.44L0.0849991 1.404L0.0579991 1.337L0.0259991 1.229L0.0159988 1.176L0.00599909 1.116L0.0019989 1.059V0.941L0.00699902 0.883L0.0159988 0.823L0.0259991 0.771L0.0579991 0.663L0.0849991 0.596L0.154999 0.464L0.219999 0.374L0.292999 0.293L0.386999 0.21L0.463999 0.156L0.559999 0.102L0.595999 0.085L0.662999 0.0579996L0.770999 0.026L0.823999 0.0159998L0.883999 0.00599957L0.940999 0.00199986L13 0Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.43f77a7c8f42f8c43636d575bd33bcd4.svg";
export { ForwardRef as ReactComponent };